/**
 * @category  HairyBaby
 * @author    Aleksejs Ivanovs <info@scandiweb.com>
 * @license   http://opensource.org/licenses/OSL-3.0 The Open Software License 3.0 (OSL-3.0)
 * @copyright Copyright (c) 2021 Scandiweb, Inc (https://scandiweb.com)
 */

export const PRIVACY_SETTINGS = 'privacy-settings';
